import React from 'react';
import ModalWrapper from '../ModalWrapper';
import { CommonFooter } from '../FormComponent';
import styles from '../../styles/assetsManagement/filesManager.module.scss';

const DeleteConfirmModal = ({ title, message, onConfirm, onClose, loading }) => {
  const buttons = [
    { label: 'Cancel', variant: 'outline', className: 'primary', onClick: onClose, disabled: loading },
    {
      label: loading ? 'Deleting…' : 'Delete',
      variant: 'primary',
      className: 'white bg-blue600',
      onClick: onConfirm,
      disabled: loading,
    },
  ];

  const hasMessage = message != null && (React.isValidElement(message) || (typeof message === 'string' && String(message).trim()));
  const displayMessage = hasMessage ? message : 'Are you sure? This action cannot be undone.';

  return (
    <ModalWrapper
      isOpen
      onClose={onClose}
      title={title}
      size="small"
      type="warning"
      footer={<CommonFooter buttons={buttons} />}
    >
      <div className={styles.deleteBody}>
        <p>{displayMessage}</p>
      </div>
    </ModalWrapper>
  );
};

export default DeleteConfirmModal;
